import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton } from 'src/components/ui'
import { useActiveFilters } from 'src/zustand/stores/filters.store'

import styles from './NoBottles.module.scss'

const NoBottles = ({
  variant,
  resetFilters,
}: {
  variant: 'no_own_bottles' | 'no_participations' | 'nothing'
  resetFilters?: () => void
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={`${styles.wrapper} ${styles[variant]}`}>
      <div>
        <h1 className={styles.title}>{t(`no_bottles_page.${variant}.title`)}</h1>
        <p className={styles.subtitle}>{t(`no_bottles_page.${variant}.subtitle`)}</p>
      </div>
      {variant === 'no_own_bottles' && (
        <CustomButton
          onClick={() => navigate('/create-bottle/step-1')}
          variant='contained'
          color='violet'
          iconType='plus'
          className={styles.button}
        >
          {t('bottles_page.create_bank')}
        </CustomButton>
      )}

      {variant === 'nothing' && (
        <CustomButton onClick={resetFilters} variant='contained' color='violet' className={styles.button}>
          {t('no_bottles_page.reset_filters')}
        </CustomButton>
      )}
    </div>
  )
}

export default NoBottles
